export default __webpack_public_path__ + "static/media/ok.b665aa90.svg";